import { render } from "./Exercise.vue?vue&type=template&id=789f8642&scoped=true"
import script from "./Exercise.vue?vue&type=script&lang=js"
export * from "./Exercise.vue?vue&type=script&lang=js"

import "./Exercise.vue?vue&type=style&index=0&id=789f8642&lang=scss"
import "./Exercise.vue?vue&type=style&index=1&id=789f8642&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789f8642"]])

export default __exports__